'use client'
import React, { useEffect, useState } from 'react';
import Link from 'next/link';
import ExpandableParagraph from '@/af_components/ExpandableParagraph';
import { CustomSelect } from '@/af_components/CustomSelect';
import { useRouter } from 'next/navigation';
import { voteDocument } from '@/af_actions/declarationActions';
import { LetterText, ThumbsDown, ThumbsUp } from 'lucide-react';
import { Show, useUser } from '@clerk/nextjs';
import CreatePolicyBox from '@/af_components/CreatePolicyBox';
import ExpandablePolicy from '@/af_components/ExpandingPolicy';
import { ShowIfRole } from '@/components/ShowIfRole';
import HSCreateResolution from './HSCreateResolution';
import { getClerkUserInfo } from '@/actions/declarationActions';

const viewOptions = [
    { value: 'accepted', label: 'Accepted Only' },
    { value: 'general', label: 'General View' },
    { value: 'all', label: 'All View' },
    { value: 'top_voted', label: 'Top Voted' }
];

const ADMIN_ID = "user_3AtnbF82V4ROWYZ4rH2PlrSsvGk";


export default function HolySeatPolicyList({ initialPolicies, userId, language, setLanguage, defaultCommitteeName, resolutionBasePath, allowedPlans, categoryFilter, defaultCategory, hideCategorySelection }: { initialPolicies: any[], userId: string | null, language: 'english' | 'american', setLanguage: (lang: 'english' | 'american') => void, defaultCommitteeName?: string, resolutionBasePath?: string, allowedPlans?: Array<'plus' | 'pro' | 'elite'>, categoryFilter?: string, defaultCategory?: string, hideCategorySelection?: boolean }) {
    const [viewMode, setViewMode] = useState('top_voted');
    const { user } = useUser();
    const isAdmin = user?.id === ADMIN_ID;

    const router = useRouter();

    const accessPlans = allowedPlans ?? ['plus', 'pro', 'elite'];
    const [hasRankAccess, setHasRankAccess] = useState(false);
    const hasChamberAccess = (has: any) => accessPlans.some((plan) => has({ plan })) || isAdmin || hasRankAccess;
    const chamberAccessLabel = accessPlans.includes('elite') ? 'elite' : accessPlans.includes('pro') ? 'pro' : 'plus';

    let voteStats = true;

    const [policies, setPolicies] = useState(initialPolicies);
    const [isLoading, setIsLoading] = useState(false);
    const [hasMore, setHasMore] = useState(true);

    useEffect(() => {
            const getActiveUser = async (userId: string) => {
                let userInfo = await getClerkUserInfo(userId);
                //setActiveUser(user as any)
                console.log(userInfo)
                console.log(userInfo?.rank)
                console.log(hasChamberAccess)
                if (!hasRankAccess) {
                    if (userInfo?.rank === "Father") {
                        console.log("User rank is Father")
                        setHasRankAccess(true);
                    }
                }
            }
           getActiveUser(user?.id);
    
    
    
    
        }, [user])

    const filteredPolicies = policies

        .filter((policy) => {
            if (viewMode === 'accepted') return policy.status === 'in_effect';
            if (viewMode === 'general') return ['in_effect', 'active'].includes(policy.status);
            return true;
        })
        .sort((a, b) => {
            if (viewMode === 'top_voted') {
                return (b.vote_count || 0) - (a.vote_count || 0);
            }
            return 0;
        });

    const handleLoadMore = async () => {
        setIsLoading(true);
        try {
            const response = await fetch('/af_api/policies/holy-seat', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    offset: policies.length,
                    limit: 10,
                    userId: user?.id,
                    category: categoryFilter
                })
            });

            if (!response.ok) throw new Error('Failed to load more policies');

            const { policies: newPolicies, hasMore: moreAvailable } = await response.json();
            setPolicies((prev) => [...prev, ...newPolicies]);
            setHasMore(moreAvailable);
        } catch (error) {
            console.error('Error loading more policies:', error);
        } finally {
            setIsLoading(false);
        }
    };

    const handleDocumentVote = async (policyId: string, type: "upvote" | "downvote") => {
        if (!user) {
            alert("You must be signed in to vote. Please sign in to continue.");
            return;
        }

        setPolicies((prev) => prev.map(p => {
            if (p.id !== policyId) return p;

            const currentVote = p.voteStats?.userVote;
            let up = p.voteStats?.upvotes || 0;
            let down = p.voteStats?.downvotes || 0;
            let totalCount = p.vote_count || 0;

            if (currentVote === type) {
                type === "upvote" ? (up--, totalCount--) : (down--, totalCount++);
                return { ...p, vote_count: totalCount, voteStats: { ...p.voteStats, upvotes: up, downvotes: down, userVote: null } };
            } else {
                if (type === "upvote") {
                    up++;
                    totalCount++;
                    if (currentVote === "downvote") {
                        down--;
                        totalCount++;
                    }
                } else {
                    down++;
                    totalCount--;
                    if (currentVote === "upvote") {
                        up--;
                        totalCount--;
                    }
                }
                return { ...p, vote_count: totalCount, voteStats: { ...p.voteStats, upvotes: up, downvotes: down, userVote: type } };
            }
        }));

        try {
            await voteDocument(policyId, type);
            await fetch("/af_api/bills/check-status/well", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ billId: policyId })
            });
        } catch (error) {
            console.error("Vote action failed:", error);
        }
    };
    //const hasBoth = firstParagraph.content && paratranslation;

    return (
        <>


            <div className="mb-6 mt-3">
                <Show when={hasChamberAccess} >
                    <HSCreateResolution userId={userId} language={language} defaultCommitteeName={defaultCommitteeName} resolutionBasePath={resolutionBasePath} defaultCategory={defaultCategory} hideCategorySelection={hideCategorySelection} />
                </Show>
            </div>

            {/*
            <div className="mb-8 w-full max-w-[200px]">
                <CustomSelect
                    value={viewMode}
                    onChange={setViewMode}
                    options={viewOptions}
                    className="font-bold uppercase tracking-widest text-[10px]"
                />
            </div>
            */}

            <div className="space-y-12">
                {filteredPolicies.map((policy) => {
                    const hasContent = !!policy.paragraphContent;
                    const hasTranslation = !!policy.paragraphTranslation;
                    let displayContent = '';
                    let isContentMissing = false;
                    let contentLanguage = '';

                    if (language === 'english') {
                        if (hasContent) {
                            displayContent = policy.paragraphContent;
                            contentLanguage = 'English';
                        } else if (hasTranslation) {
                            displayContent = policy.paragraphTranslation;
                            contentLanguage = 'American';
                            isContentMissing = true;
                        }
                    } else {
                        if (hasTranslation) {
                            displayContent = policy.paragraphTranslation;
                            contentLanguage = 'American';
                        } else if (hasContent) {
                            displayContent = policy.paragraphContent;
                            contentLanguage = 'English';
                            isContentMissing = true;
                        }
                    }


                    return (
                        <div
                            onClick={() => router.push(`${resolutionBasePath ?? '/r'}/${policy.slug}`)}
                            key={policy.id} className="block group cursor-pointer">
                            <article className="relative border border-black p-10 mb-10 bg-white/50 rounded-sm transition-all group-hover:bg-gray-100 hover:border-amber-500 hover:shadow-sm">
                                <div className="flex justify-between items-start mb-0 gap-6">
                                    <div className="flex flex-col mb-6 gap-2 w-full">
                                        <div className="flex justify-between items-start w-full">
                                            <Link href={`${resolutionBasePath ?? '/r'}/${policy.slug}`} className='hover:underline'>
                                                <h2 className="text-2xl font-bold text-slate-900 font-serif group-hover:text-blue-800 transition-colors">
                                                    {policy.title}
                                                </h2>
                                            </Link>
                                        </div>

                                        <div className="flex flex-row items-center justify-between -mb-5 w-full">
                                            <div className="flex items-center">
                                                {policy.author?.imageUrl ? (
                                                    <img
                                                        src={policy.author.imageUrl}
                                                        alt={policy.author.username}
                                                        className="w-7 h-7 rounded-full border border-amber-200"
                                                    />
                                                ) : (
                                                    <div className="w-7 h-7 rounded-full bg-slate-200" />
                                                )}
                                                <span className="text-[10px] mt-[0px] ml-2 font-bold text-slate-500 uppercase tracking-wider font-sans">
                                                    Introduced by {" "}
                                                    {policy.author?.rank && (
                                                        <span className='bg-blue-300 mr-1 px-1 text-stone-900 rounded-md'>
                                                            {policy.author?.rank === 'Founding Father' ? "Founding Father" : policy.author?.rank}
                                                        </span>
                                                    )}
                                                    <Link
                                                        className="hover:underline relative z-9"
                                                        href={`/profile/${policy.author?.username}`}
                                                        onClick={(e) => e.stopPropagation()}
                                                    >
                                                        {policy.author?.username || "Anonymous"}
                                                    </Link>
                                                </span>
                                            </div>
                                            <div className='flex flex-row'>

                                                <span className={`px-2 py-0.5 text-[10px] font-bold rounded uppercase tracking-widest whitespace-nowrap ${policy.status === "in_effect"
                                                    ? "bg-green-100 text-green-600"
                                                    : policy.status === "active"
                                                        ? "bg-amber-100 text-amber-800"
                                                        : policy.status === "effected" ? "bg-green-300 text-green-900" :
                                                            policy.status === "vetoed" ? "bg-red-300 text-red-900" :
                                                            policy.status === "tentatively_effected" ? "bg-green-200 text-green-700" :
                                                                "bg-red-100 text-red-800"
                                                    }`}>
                                                    {policy.status === "active" ? "Considering" : policy.status === "in_effect" ? "Favored" : policy.status
                                                        === "effected" ? "Effective" : policy.status === "vetoed" ? "Vetoed" : policy.status === "tentatively_effected" ? "Tentatively Effective" : "Rejected"}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="pointer-events-none mb-12 mt-3">
                                    <ExpandablePolicy
                                        content={language === 'american' && hasTranslation ? policy.paragraphTranslation : policy.paragraphContent}
                                    />
                                </div>

                                <div className="-mt-10 flex items-center justify-between text-[11px] text-gray-400 font-sans uppercase tracking-tight">
                                    <div className="flex flex-row items-center gap-2 shrink-0">
                                        <div className="text-[11px] text-gray-400 font-sans uppercase flex items-center gap-2">
                                            {policy.committee ? (
                                                <Link
                                                    href={`/assembly/committee/${policy.committee.toLowerCase().replace(/\s+/g, '-')}`}
                                                    onClick={(e) => e.stopPropagation()}
                                                    className="hover:underline text-amber-700 font-semibold"
                                                >
                                                    {policy.committee}
                                                </Link>
                                            ) : null}
                                            {policy.committee && <span>|</span>}
                                            <span className={`mr-0 text-[12px] ${policy.category === "Moral" ? "text-red-700" : policy.category === "General" ? "text-blue-700" : "text-purple-700"} text-gray-700 font-sans uppercase`}>{policy.category === "Moral" ? "Natural" : policy.category === "General" ? "Human" : policy.category} </span>
                                            <span className=''>| {' '}<span className='ml-1'></span>{new Date(policy.created_at).toLocaleDateString(undefined, { dateStyle: 'medium' })}</span>
                                        </div>

                                    </div>

                                    <Show when={hasChamberAccess}
                                        fallback={
                                            <div className="flex items-center bg-slate-50 border border-slate-200 rounded-md overflow-hidden shadow-sm" onClick={(e) => e.stopPropagation()}>
                                                <button
                                                    onClick={(e) => {
                                                        e.stopPropagation(); if (!userId) {
                                                            alert("Sign in to vote.")
                                                            return;
                                                        }
                                                        alert(`Upgrade to the ${chamberAccessLabel} plan to vote in this chamber.`)
                                                    }}
                                                    className={`p-2 transition-colors flex items-center justify-center ${policy.voteStats?.userVote === "upvote"
                                                        ? "bg-green-100 text-green-600"
                                                        : "text-slate-400 hover:bg-green-50 hover:text-green-600"
                                                        }`}
                                                >
                                                    Yea
                                                </button>

                                                <div className="px-3 text-xs font-black text-slate-700 bg-whaite border-x border-slate-200 h-full flex items-center min-w-[3rem] justify-center">
                                                    <span className={policy.status === 'in_effect' ? "text-green-600"
                                                        : policy.status === 'active' ? 'text-amber-800' : policy.status === "effected" ? "text-green-900"
                                                            : policy.status === "vetoed" ? "text-red-900" : policy.status === "tentatively_effected" ? "text-green-700" : "text-red-600"}>
                                                        {policy.vote_count > 0 ? `+${policy.vote_count}` : policy.vote_count}
                                                    </span>

                                                </div>

                                                <button
                                                    onClick={(e) => {
                                                        e.stopPropagation(); if (!userId) {
                                                            alert("Sign in to vote.")
                                                            return;
                                                        }
                                                        alert(`Upgrade to the ${chamberAccessLabel} plan to vote in this chamber.`)
                                                    }}
                                                    className={`p-2 transition-colors flex items-center justify-center ${policy.voteStats?.userVote === "downvote"
                                                        ? "bg-red-100 text-red-600"
                                                        : "text-slate-400 hover:bg-red-50 hover:text-red-600"
                                                        }`}
                                                >
                                                    Nay
                                                </button>
                                            </div>

                                        } >

                                        <div className="flex items-center bg-slate-50 border border-slate-200 rounded-md overflow-hidden shadow-sm" onClick={(e) => e.stopPropagation()}>
                                            <button
                                                onClick={(e) => { e.stopPropagation(); handleDocumentVote(policy.id, "upvote"); }}
                                                className={`p-2 transition-colors flex items-center justify-center ${policy.voteStats?.userVote === "upvote"
                                                    ? "bg-green-100 text-green-600"
                                                    : "text-slate-400 hover:bg-green-50 hover:text-green-600"
                                                    }`}
                                            >
                                                Yea
                                            </button>

                                            <div className="px-3 text-xs font-black text-slate-700 bg-whaite border-x border-slate-200 h-full flex items-center min-w-[3rem] justify-center">
                                                <span className={policy.status === 'in_effect' ? "text-green-600"
                                                    : policy.status === 'active' ? 'text-amber-800' : policy.status === "effected" ? "text-green-900"
                                                        : policy.status === "vetoed" ? "text-red-900" : policy.status === "tentatively_effected" ? "text-green-700" : "text-red-600"}>
                                                    {policy.vote_count > 0 ? `+${policy.vote_count}` : policy.vote_count}
                                                </span>

                                            </div>

                                            <button
                                                onClick={(e) => { e.stopPropagation(); handleDocumentVote(policy.id, "downvote"); }}
                                                className={`p-2 transition-colors flex items-center justify-center ${policy.voteStats?.userVote === "downvote"
                                                    ? "bg-red-100 text-red-600"
                                                    : "text-slate-400 hover:bg-red-50 hover:text-red-600"
                                                    }`}
                                            >
                                                Nay
                                            </button>
                                        </div>


                                    </Show>
                                </div>
                            </article>
                        </div>
                    );
                })}

                {filteredPolicies.length === 0 && (
                    <div className="text-center py-20 text-gray-500 font-serif italic">
                        No resolutions found.
                    </div>
                )}
            </div>

            {hasMore && (
                <div className="flex justify-center mt-12">
                    <button
                        onClick={handleLoadMore}
                        disabled={isLoading}
                        className="px-8 py-3 bg-slate-900 text-white font-bold uppercase tracking-widest text-sm rounded hover:bg-slate-800 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                        {isLoading ? 'Loading...' : 'Load More'}
                    </button>
                </div>
            )}
        </>
    );
}